export default __webpack_public_path__ + "static/slick-animation-b445fd82fa6985ae842548dd89ca62d8.gif";